// DinaBase7 DR v1 — countdown + stock + sticky observer
(function() {
  // Countdown — resets per session, 27 minutes from load
  var COUNTDOWN_MIN = 27;
  var endTime = Date.now() + COUNTDOWN_MIN * 60 * 1000;
  var el = document.querySelector('[data-dr-countdown]');
  if (el) {
    var tick = function() {
      var diff = Math.max(0, endTime - Date.now());
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (diff <= 0) { el.textContent = '00:00'; return; }
      requestAnimationFrame(function() { setTimeout(tick, 1000); });
    };
    tick();
  }

  // Stock counter: randomize between 140-220 once per session, store in sessionStorage
  var stockEl = document.querySelector('[data-dr-stock]');
  if (stockEl) {
    var stored = sessionStorage.getItem('dr_stock');
    if (!stored) {
      stored = Math.floor(140 + Math.random() * 80);
      sessionStorage.setItem('dr_stock', stored);
    }
    stockEl.textContent = stored;
  }

  // Sticky mobile CTA reveal only after hero scrolled past
  var sticky = document.querySelector('.dr-sticky-cta');
  var hero = document.querySelector('.dr-hero');
  if (sticky && hero) {
    sticky.style.display = 'none';
    window.addEventListener('scroll', function() {
      if (window.innerWidth <= 900) {
        var heroBottom = hero.getBoundingClientRect().bottom;
        sticky.style.display = heroBottom < 0 ? 'block' : 'none';
      } else {
        sticky.style.display = 'none';
      }
    });
  }

  // Smooth scroll for product-image-to-bundle dead-click-fix
  document.querySelectorAll('[data-dr-scroll]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.querySelector(el.getAttribute('data-dr-scroll'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
